module.exports = {
  langs: ['en', 'fr', 'it'],
  defaultLangKey: 'en',
};
